import type { FirewallRule } from '#dn-types/role.ts';
import { ALL_ROLES_FLAG } from '../firewall-rule-form/FirewallRuleForm.queries.ts';
import type { FirewallRuleFormValues } from '../types.ts';

/**
 * Maps firewall rules from the API shape into the form-values shape used by the shared firewall-rule
 * editing components. Shared by the role and tag forms.
 */
export function mapFirewallRulesToRoleForm(firewallRules: FirewallRule[]): FirewallRuleFormValues[] {
  return firewallRules.map((rule) => ({
    portRange: rule.portRange,
    description: rule.description,
    protocol: rule.protocol,
    allowedRoleID: rule.allowedRoleID ?? ALL_ROLES_FLAG,
    tags: rule.allowedTags ?? [],
  }));
}

/**
 * Maps firewall rules from the form-values shape back into the API shape. The select box requires a
 * string value, so {@link ALL_ROLES_FLAG} is translated back to `null` ("all hosts"). Shared by the
 * role and tag forms.
 */
export function mapFormValuesToFirewallRules(formValues: FirewallRuleFormValues[]): FirewallRule[] {
  return formValues.map((rule) => ({
    portRange: rule.portRange,
    description: rule.description,
    protocol: rule.protocol,
    allowedRoleID: rule.allowedRoleID === ALL_ROLES_FLAG ? null : rule.allowedRoleID,
    allowedTags: rule.tags,
  }));
}
